export default __webpack_public_path__ + "static/media/logo.96bdf340.png";